import React from "react";
import { withRouter } from "react-router-dom";
import SegmentWrapper from "./SegmentWrapper";

class RouteChangeHandler extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      sessionStorage.getItem("segment_userId") &&
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      trackPageViews();
    }
  }

  componentDidMount() {
    const MAX_RETRIES = 10;
    let retryCount = 0;
    let checkInterval = setInterval(() => {
      retryCount++;
      if (sessionStorage.getItem("segment_userId")) {
        clearInterval(checkInterval);
        trackPageViews();
      } else if (retryCount >= MAX_RETRIES) {
        clearInterval(checkInterval);
        sessionStorage.setItem("segment_userId", "anonymous");
        trackPageViews();
      }
    }, 500);
  }

  render() {
    return <SegmentWrapper />;
  }
}

const trackPageViews = () => {
  if (window.analytics?.page) {
    window.analytics.page();
  }
};

export default withRouter(RouteChangeHandler);
